// extracted by mini-css-extract-plugin
export var fadeInOut = "_30-3";
export var icon = "_30-4";
export var savedIndicator = "_30-2";
export var savingIndicator = "_30-0";
export var spin = "_30-1";